import React from 'react';
import { Building2 } from 'lucide-react';


const WhyInvest = ({ highlights }) => {
    if (!highlights || highlights.length === 0) return null;

    return (
        <div className="bg-black rounded-xl overflow-hidden relative border border-white/10 my-8 shadow-2xl">
            {/* Background Graphic Background - Full Length */}
            <div className="absolute inset-0 w-full h-full overflow-hidden z-0 pointer-events-none">
                <img
                    src="/why_invest_graphic.avif"
                    alt="Investment Highlights"
                    className="absolute inset-x-0 inset-y-0 w-full h-full object-cover object-center translate-x-1/4 scale-110 opacity-80"
                />
                {/* Artistic gradient overlays for readability */}
                <div className="absolute inset-0 w-full h-full bg-gradient-to-r from-black via-black/90 to-black/20" />
                <div className="absolute inset-0 w-full h-full bg-gradient-to-b from-black/40 via-transparent to-black/40" />
            </div>

            <div className="relative z-10 p-6 md:p-14">
                {/* Text Content */}
                <div className="max-w-3xl">
                    <div className="flex items-center gap-4 md:gap-5 mb-8 md:mb-12">
                        <h2 className="text-2xl md:text-4xl font-black text-white tracking-tight leading-tight uppercase">
                            WHY INVEST IN THIS PROPERTY?
                        </h2>
                    </div>

                    <div className="grid grid-cols-1 gap-y-8 md:gap-y-10">
                        {highlights.map((item, idx) => (
                            <div key={idx} className="space-y-2 md:space-y-3">
                                <h3 className="text-white text-lg md:text-xl font-black tracking-tight">{item.title}</h3>
                                <p className="text-gray-300 text-sm md:text-base leading-relaxed font-bold">{item.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Subtle background glow */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-emerald-600/10 blur-[100px] -mr-32 -mt-32 pointer-events-none" />
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-emerald-600/5 blur-[120px] -ml-32 -mb-32 pointer-events-none" />
        </div>
    );
};

export default WhyInvest;
